'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { prefix: '' },
        prefix = _ref.prefix;

    return function (target) {
        var ContentConnectorHOC = function (_React$Component) {
            (0, _inherits3.default)(ContentConnectorHOC, _React$Component);

            function ContentConnectorHOC(props, context) {
                (0, _classCallCheck3.default)(this, ContentConnectorHOC);

                var _this = (0, _possibleConstructorReturn3.default)(this, (ContentConnectorHOC.__proto__ || (0, _getPrototypeOf2.default)(ContentConnectorHOC)).call(this, props, context));

                _this._createContent();
                return _this;
            }

            (0, _createClass3.default)(ContentConnectorHOC, [{
                key: 'componentWillReceiveProps',
                value: function componentWillReceiveProps(nextProps) {
                    if (nextProps.i18n.localeData !== this.props.i18n.localeData) {
                        this._createContent();
                    }
                }
            }, {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(target, (0, _extends3.default)({}, this.props, { content: this.content }));
                }
            }, {
                key: 'shouldComponentUpdate',
                value: function shouldComponentUpdate() {
                    return true;
                }
            }, {
                key: '_createContent',
                value: function _createContent() {
                    var i18n = this.props.i18n;

                    var i18nImpl = new _restaurantsI18nJs.I18N(i18n.localeData);
                    var translatedContent = new _TranslatedContent2.default({ header: this.context.contentProps.appHeader,
                        tokens: this.context.contentProps.appTokens,
                        i18n: i18nImpl
                    });
                    this.content = translatedContent.instance(prefix);
                }
            }]);
            return ContentConnectorHOC;
        }(_react2.default.Component);

        ContentConnectorHOC.contextTypes = {
            contentProps: _propTypes2.default.object
        };

        function mapStateToProps(state) {
            return {
                i18n: state.i18nData
            };
        }

        function mapDispatchToProps() {
            return {};
        }

        return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContentConnectorHOC);
    };
};

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _TranslatedContent = require('@wix/wixrest-utils/dist/TranslatedContent');

var _TranslatedContent2 = _interopRequireDefault(_TranslatedContent);

var _restaurantsI18nJs = require('@wix/restaurants-i18n-js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }